module.exports = {"userListFilters":[{"type":"text","name":"User Name","placeholder":"User Name","field":"q"},{"type":"selector","name":"Source","field":"type","selectors":[{"label":"ALL","value":""},{"label":"Passpod","value":"passpod","restriction":"PH"},{"label":"Travypass","value":"travypass","restriction":"PH"}]},{"type":"dateTime","name":"From","field":"registration_from"},{"type":"dateTime","name":"To","field":"registration_until"}]}


//////////////////
// WEBPACK FOOTER
// ./src/Pages/User/filterData.json
// module id = 878
// module chunks = 0